export const TILE_SIZE = 50;
export const LAYER_DEPTH = 20;
export const COIN_SIZE = 15;
export const COIN_COLOR = '#ffcf00';
export const HEART_COLOR = '#fb4e4e';
export const GAS_CONSUMPTION = .2;
export const GAS_COLOR = '#318890';
export const GAS_CRITICAL_COLOR = '#fb4e4e';
export const PLAYER_MOVE_DURATION = 200;